import {ExtendedLink, HttpMethod, ResourceLink} from './types';
import {httpService} from '@malt/http-client';

export async function $fetch<T>({url, method = HttpMethod.GET}: ExtendedLink, params?: Record<string, any>, logger?: boolean): Promise<T | null> {
    try {
        const [data, error] = await httpService.request<T>(
            {
                url,
                method,
                ...(params && {params}),
            },
            logger,
        );
        if (error) {
            return Promise.reject(error);
        } else {
            return data;
        }
    } catch (e) {
        return Promise.reject(e);
    }
}

export function safeUriDecode(uri: string): string {
    try {
        return decodeURIComponent(uri);
    } catch (err) {
        return '';
    }
}

export function findResourceLink(key: string, links: ResourceLink[] | null): ResourceLink | undefined {
    return links?.find((link) => link.rel === key);
}

export function cleanResourceLinks(links: ResourceLink[]): ResourceLink[] {
    return links.map(({href, ...rest}) => ({...rest, href: safeUriDecode(href)}));
}
